<div class="header mt-3" style="background-image: url({{cityCertificationResume?.areaImgUrl}})">
  <div class="title">{{certificationArea[cityCertificationResume?.certificationAreaId]}}</div>
</div>
<div class="content mb-3">
  <div class="row align-items-center">
    <!-- <div class="col-md-8 col-12 indicator-label" [translate]="'city-profile-certification/area/select-indicator'">
      Selecione indicador que deseja preencher:
    </div>
    <div class="col-md-4 col-12">
      <mat-form-field style="width: 100%;">
        <mat-select (selectionChange)="handleSelectIndicator($event.value)" [value]="indicators[0].refCode">
          <mat-option *ngFor="let indicator of indicators; let i = index" [value]="indicator.refCode">
            {{indicator.refCode}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <div class="col-12 btn-container">
      <button mat-stroked-button (click)="handleBegin()">
        <ng-container
          *ngIf="cityCertificationResume?.totalEssentialIndicatorsFilled || cityCertificationResume?.totalSupportIndicatorsFilled; else init">
          <span [translate]="'city-profile-certification/continue'">COMEÇAR</span>
        </ng-container>
        <ng-template #init>
          <span [translate]="'city-profile-certification/start'">COMEÇAR</span>
        </ng-template>
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="row footer-area">
    <div class="col-12 text-center label" [translate]="'city-profile-certification/area/indicators-completed'">
      INDICADORES PREENCHIDOS</div>
    <div class="col-12 text-center value">
      {{cityCertificationResume?.totalEssentialIndicatorsFilled || 0}} /
      {{cityCertificationResume?.totalEssentialIndicators || 0}}
      <span [translate]="'city-profile-certification/essential'">essencial</span> |
      {{cityCertificationResume?.totalSupportIndicatorsFilled || 0}} / {{cityCertificationResume?.totalSupportIndicators
      || 0}}
      <span [translate]="'city-profile-certification/support'">apoio</span>
    </div>
  </div>
</div>